const secrets = {
    third_party_token_set: {
        token_not_found: 'Enregistrement de token non trouvé.',
        access_token_expired: "Le jeton d'accès a expiré. Veuillez reconnecter votre compte.",
    },
};
export default Object.freeze(secrets);
